import { styled } from '@mui/material/styles';
import { Role } from '@bloomays-lib/types.shared';
import { TitlePart } from '@bloomays-lib/ui.shared';
import { Navigate } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { useAuthStore } from '../../stores';
import hourglass from '../../graphic-charter/illustrations/hourglass.png';
import MonthlyPrime from '../organisms/MonthlyPrime';

const Primes = () => {
  const { t } = useTranslation(['primes']);
  const auth = useAuthStore((state) => state.auth);

  const isAdmin = auth?.user?.roles?.includes(Role.Admin) || false;
  const isSystem = auth?.user?.roles?.includes(Role.System) || false;
  const showMonthlyPrime = isAdmin && !isSystem;

  if (!isAdmin && !isSystem) {
    return <Navigate to="/forbidden/norole" replace />;
  }

  return (
    <Container>
      <TitlePart textTitle={t('title')} />

      {showMonthlyPrime ? (
        <MonthlyPrime />
      ) : (
        <ComingSoonContainer>
          <Image src={hourglass} />
          <TitlePart textTitle={t('comingSoon')} />
        </ComingSoonContainer>
      )}
    </Container>
  );
};

export default Primes;

const Container = styled('div')(({ theme }) => ({
  margin: '0 80px',
  [theme.breakpoints.down('sm')]: {
    margin: 0,
  },
}));

const ComingSoonContainer = styled('div')(() => ({
  marginTop: '32px',
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'center',
  justifyContent: 'center',
  gap: '20px',
}));

const Image = styled('img')(() => ({
  maxWidth: '280px',
  width: '100%',
  height: 'auto',
}));
